// @flow
import {type Action as HeaderActions} from '../actions/header';

export type State = {};

export default function reducer(
    state: State = {},
    action: HeaderActions
): State {
    switch (action.type) {
        case 'HEADER/INIT':
            return {...state, ...action.payload};
        default:
            (action: empty); // eslint-disable-line no-unused-expressions
            return state;
    }
}
